<template>
  <div class="feedbackPopup" id="feedbackPopup">
    <div class="title">{{$t("Feedback")}}</div>
    <div>
      <div v-show="!showThanks">
        <div class="helpfulButton">
          <p>{{$t("Was_this_page_helpful")}}</p>
          <div>
            <el-button class="feedback-button" @click="sendFeedbackEvent(true)">YES</el-button>
            <el-button class="feedback-button" @click="sendFeedbackEvent(false)">NO</el-button>
          </div>
        </div>
      </div>
      <transition name="bounce">
        <div class="thanksTitle" v-show="showThanks">
          <i class="icon-check"></i>
          <span>{{$t("Thanks_for_the_feedback")}}</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import frontAPI from '@/api/frontstage/frontAPI'

export default {
  name: 'feedbackPopup',
  props: {
    log_id: Number,
    version: String,
    isPreview: Boolean
  },
  data () {
    return {
      like: '',
      showThanks: false
    }
  },
  created () {
  },
  methods: {
    sendFeedbackEvent (isLiked) {
      const param = {
        like: isLiked,
        content: '',
        doc_log_id: this.log_id,
        version: this.version
      }
      this.showThanks = true
      if (!this.isPreview) {
        frontAPI
          .insertFeedback(param)
          .then(data => {
          })
          .catch(err => {
            console.log('insertFeedback error---', err)
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.feedbackPopup {
  border-bottom: solid 1px #c8c8c8;
  border-top: solid 1px #c8c8c8;
  padding-top: 16px;
  .title {
    line-height: 40px;
    font-size: 24px;
    font-weight: bold;
    font-family: "Roboto Bold", "Microsoft JhengHei";
    color: #008cd6;
  }
}

.helpfulButton {
  margin-top: 16px;
  margin-bottom: 16px;
  margin-right: 12px;
  p {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: bold;
    font-family: "Roboto Bold", "Microsoft JhengHei";
    line-height: 24px;
    padding: 0;
    color: #787878;
  }
  .feedback-button {
    font-size: 13px;
    line-height: 14px;
    font-weight: bold;
    font-family: "Roboto Bold", "Microsoft JhengHei" ;
    color: #008cd6;
    padding: 7px 10px 7px 10px;
    border: solid 2px #008cd6;
    border-radius: 0;
    margin-right: 16px;
    cursor: pointer;
    margin-left: 0;
  }
  .feedback-button:hover {
    color: #008cd6;
    background-color: #e5f6ff;
  }
  .feedback-button:active {
    color: #fff;
    background-color: #008cd6;
  }
}
.helpfulMessages {
  margin-right: 24px;
  p {
    font-size: 16px;
    font-weight: bold;
    font-family: "Roboto Bold", "Microsoft JhengHei";
    line-height: 32px;
    margin-top: 16px;
    margin-bottom: 8px;
    padding: 0;
    color: #787878;
  }
}

.thanksTitle {
  margin-top: 36px;
  margin-bottom: 36px;
  margin-left: 16px;
  line-height: 32px;
  font-size: 18px;
  color: #787878;
  display: flex;
  .icon-check {
    margin-right: 8px;
    display: inline-block;
    vertical-align: middle;
    width: 32px;
    height: 32px;
    background-size: 32px;
    background-image: url("../../assets/icon/btn_main_confirm2_normal.svg");
  }
  span {
    flex: 1;
  }
  @media (max-width: 920px) {
    margin-left: 0;
    line-height: initial;
    font-size: 16px;
    padding-right: 10px;
  }
}
</style>
<style>
.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity 0.2s;
}
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: opacity 0.2s;
}
.v-enter-to {
  opacity: 1;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>
